import React, { Component } from "react";
import axios from "axios";
import Swal from "sweetalert2";

class CancelSubscription extends Component {
    reasonOptions = [
        "El precio es muy alto",
        "Ya no necesito la plataforma",
        "No estoy utilizando el servicio",
        "Falta de funcionalidades que necesito",
        "La plataforma es difícil de usar",
        "Problemas técnicos o errores frecuentes",
        "El soporte no cumplió mis expectativas",
        "Encontré una mejor alternativa",
        "Mi empresa ya no requiere este tipo de servicio",
        "Proyecto finalizado",
        "Problemas con integraciones (ej. Doc2Sign, Venvers)",
        "Rendimiento lento o inestable",
        "Falta de personalización",
        "Proceso de implementación complicado",
        "No cumplió con mis expectativas",
        "Otro (especificar)",
    ];

    constructor(props) {
        super(props);
        this.state = {
            showModal: false,
            currentStep: 1,
            selectedReason: "",
            customReason: "",
            confirmText: "",
            isSubmitting: false,
            responseMessage: "",
            responseType: "",
            connectedIntegrations: [],
            usage: {
                dossiers: 0,
                users: 0,
                storage: 0,
            },
        };
    }

    componentDidMount() {
        this.getPersonUsage();
        this.loadConnectedIntegrations();
    }

    getPersonUsage = () => {
        axios
            .get("/api/usage")
            .then((res) => {
                this.setState({
                    usage: {
                        dossiers: res.data.dossiers || 0,
                        users: res.data.users || 0,
                        storage: res.data.storage || 0,
                    },
                });
            })
            .catch(() => {
                this.setState({
                    usage: {
                        dossiers: 0,
                        users: 0,
                        storage: 0,
                    },
                });
            });
    };

    loadConnectedIntegrations = async () => {
        const integrations = [];

        const hasVenvers = Array.isArray(this.props.personVenvers)
            && this.props.personVenvers.some((item) => item && item.api_key);

        if (hasVenvers) {
            integrations.push("Venvers");
        }

        try {
            const response = await axios.get("/api/doc2sign-credentials");
            const doc2signCredentials = response?.data?.data;

            if (doc2signCredentials) {
                integrations.push("Doc2sign");
            }
        } catch (error) {
            // Si no hay credenciales o falla la consulta, simplemente no se agrega Doc2Sign.
        }

        this.setState({ connectedIntegrations: integrations });
    };

    getCurrentPlanName = () => {
        return this.props.subscription?.billing_plan?.name || "Plan actual";
    };

    getCurrentTermEndDate = () => {
        return this.props.subscriptionEndDate || "-";
    };

    isSubscriptionCancelled = () => {
        const status = this.props.subscription?.status?.name || this.props.subscription?.status?.status || "";
        return ["non_renewing", "cancelled", "canceled"].includes(String(status).toLowerCase()) || Boolean(this.props.subscription?.end_of_term);
    };

    openModal = () => {
        this.setState({
            showModal: true,
            currentStep: 1,
            selectedReason: "",
            customReason: "",
            confirmText: "",
            isSubmitting: false,
            responseMessage: "",
            responseType: "",
        });
    };

    closeModal = () => {
        if (this.state.isSubmitting) {
            return;
        }

        this.setState({
            showModal: false,
            currentStep: 1,
            selectedReason: "",
            customReason: "",
            confirmText: "",
            isSubmitting: false,
            responseMessage: "",
            responseType: "",
        });
    };

    handleReasonChange = (e) => {
        const value = e.target.value;
        this.setState({
            selectedReason: value,
            customReason: value === "Otro (especificar)" ? "" : value,
        });
    };

    handleCustomReasonChange = (e) => {
        this.setState({ customReason: e.target.value });
    };

    handleConfirmTextChange = (e) => {
        this.setState({ confirmText: e.target.value });
    };

    goToStepTwo = () => {
        if (!this.state.selectedReason) {
            return;
        }

        this.setState({
            currentStep: 2,
            responseMessage: "",
            responseType: "",
        });
    };

    goToStepOne = () => {
        if (this.state.isSubmitting) {
            return;
        }

        this.setState({
            currentStep: 1,
            responseMessage: "",
            responseType: "",
        });
    };

    handleCancelSubscription = async () => {
        if (!this.props.subscriptionId || this.state.confirmText !== "CANCELAR") {
            return;
        }

        this.setState({
            isSubmitting: true,
            responseMessage: "",
            responseType: "",
        });

        try {
            const response = await axios.post(
                `/api/zoho/subscriptions/${this.props.subscriptionId}/cancel`,
                {
                    cancel_at_end: true,
                    reason: this.state.customReason,
                }
            );

            const successMessage =
                response?.data?.message ||
                "Tu suscripción se cancelará al finalizar el periodo actual.";

            this.setState({
                showModal: false,
                currentStep: 1,
                selectedReason: "",
                customReason: "",
                confirmText: "",
                isSubmitting: false,
                responseMessage: "",
                responseType: "",
            }, () => {
                Swal.fire({
                    title: "Suscripción cancelada",
                    text: successMessage,
                    icon: "success",
                    confirmButtonText: "Aceptar",
                });
            });
        } catch (error) {
            this.setState({
                isSubmitting: false,
                responseMessage:
                    error?.response?.data?.message ||
                    "No fue posible cancelar la suscripción. Inténtalo de nuevo.",
                responseType: "danger",
            });
        }
    };

    handleContactCollaborator = async () => {
        if (this.state.isSubmitting) {
            return;
        }

        this.setState({
            isSubmitting: true,
            responseMessage: "",
            responseType: "",
        });

        try {
            const response = await axios.post('/api/subscription-cancellation/contact-collaborator', {
                reason: this.state.customReason,
            });
            const successMessage = response?.data?.message || 'En breve se pondrán en contacto contigo.';

            this.setState({
                showModal: false,
                currentStep: 1,
                selectedReason: "",
                customReason: "",
                confirmText: "",
                isSubmitting: false,
                responseMessage: "",
                responseType: "",
            }, () => {
                Swal.fire({
                    title: 'Solicitud enviada',
                    text: successMessage,
                    icon: 'success',
                    confirmButtonText: 'Aceptar',
                });
            });
        } catch (error) {
            this.setState({
                isSubmitting: false,
                responseMessage:
                    error?.response?.data?.message ||
                    'No fue posible contactar a un colaborador. Inténtalo de nuevo.',
                responseType: 'danger',
            });
        }
    };

    renderResponseMessage() {
        if (!this.state.responseMessage) {
            return null;
        }

        return (
            <div
                className={`alert alert-${this.state.responseType} mt-4 mb-0`}
                role="alert"
            >
                {this.state.responseMessage}
            </div>
        );
    }

    renderStepOne() {
        const continueDisabled = !this.state.selectedReason || (this.state.selectedReason === "Otro (especificar)" && !this.state.customReason.trim()) || this.state.isSubmitting;

        return (
            <>
                <div className="modal-header border-0 pb-0">
                    <h5 className="modal-title text-dark font-weight-bold">Cancelar Plan</h5>
                    <button type="button" className="close" onClick={this.closeModal} disabled={this.state.isSubmitting}>
                        <span>&times;</span>
                    </button>
                </div>
                <div className="modal-body pt-5">
                    <div className="mt-3 alert alert-warning" style={{backgroundColor: '#FFF3CD', color: '#92400E'}}>
                        <div className="d-flex flex-column">
                            <div className="d-flex">
                                <svg className="mr-4" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M18.109 15L11.4423 3.33333C11.297 3.07684 11.0862 2.86349 10.8314 2.71506C10.5767 2.56662 10.2872 2.48842 9.99234 2.48842C9.69752 2.48842 9.40797 2.56662 9.15324 2.71506C8.8985 2.86349 8.6877 3.07684 8.54234 3.33333L1.87567 15C1.72874 15.2545 1.6517 15.5433 1.65235 15.8371C1.653 16.1309 1.73132 16.4194 1.87938 16.6732C2.02744 16.927 2.23996 17.1372 2.49542 17.2824C2.75088 17.4276 3.04018 17.5026 3.33401 17.5H16.6673C16.9598 17.4997 17.2469 17.4225 17.5001 17.2761C17.7532 17.1297 17.9634 16.9192 18.1094 16.6659C18.2555 16.4126 18.3324 16.1253 18.3323 15.8329C18.3322 15.5405 18.2552 15.2532 18.109 15Z" stroke="#F59E0B" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
                                    <path d="M10 7.5V10.8333" stroke="#F59E0B" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
                                    <path d="M10 14.1667H10.0083" stroke="#F59E0B" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                                <p className="mb-2"><strong>Tu plan permanecerá activo hasta el {this.getCurrentTermEndDate()}</strong></p>
                            </div>
                            <div>
                                <p className="mb-0">Después de esa fecha, perderás acceso a todos tus expedientes y documentos.</p>
                            </div>
                        </div>
                    </div>

                    <div className="table-responsive mb-6">
                        <table className="table table-borderless m-0 table-valign bg-light">
                            <tbody>
                                <tr>
                                    <td className="font-weight-bolder text-dark d-flex align-items-center">
                                        <i className="flaticon2-open-text-book icon-lg  mr-3 text-primary"></i>
                                        <span>{this.state.usage.dossiers} expedientes creados</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td className="font-weight-bolder text-dark d-flex align-items-center">
                                        
                                        <i className="flaticon-users icon-lg mr-3 text-primary"></i>
                                        <span>{this.state.usage.users} usuarios colaboradores activos</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td className="font-weight-bolder text-dark d-flex align-items-center">
                                        <i className="flaticon-open-box icon-lg mr-3 text-primary"></i>
                                        <span>{this.state.usage.storage} GB de almacenamiento en uso</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td className="font-weight-bolder text-dark d-flex align-items-center">
                                        <i className="flaticon-interface-8 icon-lg mr-3 text-primary"></i>
                                        <span>
                                            {this.state.connectedIntegrations.length > 0
                                                ? `Integraciones ${this.state.connectedIntegrations.join(', ')}`
                                                : 'Sin integraciones conectadas'}
                                        </span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div className="form-group">
                        <label className="font-weight-bolder text-dark-50">¿Por qué deseas cancelar?</label>
                        <select
                            className="form-control form-control-solid  "
                            value={this.state.selectedReason}
                            onChange={this.handleReasonChange}
                            disabled={this.state.isSubmitting}
                        >
                            <option value="">Selecciona un motivo</option>
                            {this.reasonOptions.map((reason) => (
                                <option key={reason} value={reason}>{reason}</option>
                            ))}
                        </select>
                    </div>

                    <div className="form-group">
                        <input
                            type="text"
                            className="form-control form-control-solid"
                            value={this.state.customReason}
                            onChange={this.handleCustomReasonChange}
                            readOnly={this.state.selectedReason !== "Otro (especificar)"}
                            placeholder={this.state.selectedReason === "Otro (especificar)" ? "Especifica el motivo" : "Motivo seleccionado"}
                        />
                    </div>

                    <div className="form-group mb-0">
                        <label className="font-weight-bolder text-dark-50">¿Podemos ayudarte antes de que te vayas?</label>
                        <button
                            type="button"
                            className="form-control d-flex align-items-center justify-content-between  form-control-solid"
                            onClick={this.handleContactCollaborator}
                            disabled={this.state.isSubmitting}
                            style={{ border: '1px solid #E4E6EF' }}
                        >
                            <div className="d-flex align-items-center">
                                <i className="flaticon-email icon-lg mr-3 text-primary"></i>
                                <span className="font-weight-bolder text-dark">Contacta a un colaborador</span>
                            </div>
                            <span className="text-muted">&gt;</span>
                        </button>
                    </div>
                </div>
                <div className="modal-footer">
                    <button type="button" className="btn btn-light-primary font-weight-bolder" onClick={this.closeModal} disabled={this.state.isSubmitting}>
                        Cerrar
                    </button>
                    <button
                        type="button"
                        className="btn btn-secondary font-weight-bolder"
                        onClick={this.goToStepTwo}
                        disabled={continueDisabled}
                    >
                        Continuar
                    </button>
                </div>
            </>
        );
    }

    renderStepTwo() {
        const confirmDisabled = this.state.confirmText !== "CANCELAR" || this.state.isSubmitting || !this.props.subscriptionId;

        return (
            <>
                <div className="modal-header border-0 pb-0">
                    <h5 className="modal-title text-dark font-weight-bold">Confirmar cancelación</h5>
                    <button type="button" className="close" onClick={this.closeModal} disabled={this.state.isSubmitting}>
                        <span>&times;</span>
                    </button>
                </div>
                <div className="modal-body pt-5">
                    <p className="text-muted font-weight-bold mb-4">Resumen de tu cancelación</p>

                    <div className="table-responsive mb-6">
                        <table className="table table-borderless m-0 table-valign bg-light">
                            <tbody>
                                <tr>
                                    <td className="font-weight-bolder text-dark-50">Plan actual</td>
                                    <td className="text-right font-weight-bolder  ">{this.getCurrentPlanName()}</td>
                                </tr>
                                <tr>
                                    <td className="font-weight-bolder text-dark-50">Activo hasta</td>
                                    <td className="text-right font-weight-bolder  ">{this.getCurrentTermEndDate()}</td>
                                </tr>
                                <tr>
                                    <td className="font-weight-bolder text-dark-50">Motivo</td>
                                    <td className="text-right font-weight-bolder  ">{this.state.customReason}</td>
                                </tr>
                                <tr>
                                    <td colSpan={2} className="font-weight-bolder text-dark-50">La información seguirá almacenada hasta el {this.getCurrentTermEndDate()}.</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div className="form-group">
                        <label className="font-weight-bolder text-dark">Para confirmar escribe CANCELAR:</label>
                        <input
                            type="text"
                            className="form-control form-control-solid"
                            value={this.state.confirmText}
                            onChange={this.handleConfirmTextChange}
                            placeholder="Escribe CANCELAR aquí"
                            disabled={this.state.isSubmitting}
                        />
                    </div>

                    {this.renderResponseMessage()}
                </div>
                <div className="modal-footer"> 
                    <button type="button" className="btn btn-secondary font-weight-bolder" onClick={this.goToStepOne}  > 
                        Regresar
                    </button>
                    <button
                        type="button"
                        className="btn btn-danger font-weight-bolder"
                        disabled={confirmDisabled}
                        onClick={this.handleCancelSubscription}
                    >
                        {this.state.isSubmitting ? "Cancelando..." : "Confirmar"}
                    </button>
                </div>
            </>
        );
    }

    render() {
        const buttonDisabled = !this.props.subscriptionId;
        const isCancelled = this.isSubscriptionCancelled();

        return (
            <>
                {this.props.inlineTrigger ? (
                    <div className="mt-8">
                        {isCancelled ? (
                            <span className="text-muted font-weight-bolder">Subscripción Cancelada</span>
                        ) : (
                            <button
                                type="button"
                                className="btn btn-link p-0 text-muted font-weight-bolder"
                                onClick={this.openModal}
                                disabled={buttonDisabled}
                            >
                                Cancelar suscripción
                            </button>
                        )}
                    </div>
                ) : (
                    <div className="card card-custom mt-6">
                        <div className="card-body d-flex justify-content-end">
                            {isCancelled ? (
                                <span className="text-muted font-weight-bolder">Subscripción Cancelada</span>
                            ) : (
                                <button type="button" className="btn btn-danger font-weight-bolder" onClick={this.openModal} disabled={buttonDisabled}>
                                    Cancelar subscripción
                                </button>
                            )}
                        </div>
                    </div>
                )}

                {this.state.showModal && (
                    <>
                        <div className="modal fade show" style={{ display: "block" }} tabIndex="-1" role="dialog">
                            <div className="modal-dialog modal-dialog-centered" role="document">
                                <div className="modal-content">
                                    {this.state.currentStep === 1 ? this.renderStepOne() : this.renderStepTwo()}
                                </div>
                            </div>
                        </div>
                        <div className="modal-backdrop fade show"></div>
                    </>
                )}
            </>
        );
    }
}

export default CancelSubscription;
